"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEditPage = exports.FormEditPageConfig = exports.CSS = void 0;
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const form_designer_1 = require("../modules/form.designer/form.designer");
const services_1 = require("../services");
const store_1 = require("../store");
const page_1 = require("./page");
exports.CSS = {
    container: 'c-FormEdit'
};
const Style = {
    [exports.CSS.container]: {
        height: '100%',
        width: '80%'
    }
};
(0, theme_1.addStyles)(Style);
exports.FormEditPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.formEdit,
    path: '/form/edit/:version',
    auth: {
        required: true
    }
};
class FormEditPage extends page_1.IkePage {
    constructor() {
        super(exports.FormEditPageConfig);
    }
    init() {
        this.formVersion = services_1.Services.Route.params.get('version');
        this.designer = new form_designer_1.FormDesigner();
        this.designer.setEditing(true);
        store_1.AppStore.Form.fetch(this.formVersion)
            .then(form => this.designer.setForm(form))
            .catch(e => services_1.Services.Log.Logger.error(e));
    }
    get nodes() {
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (this.designer == null) {
            this.init();
        }
        const userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
        if (!services_1.Services.UserProfile.canEditForms(userProfile)) {
            return null;
        }
        if (!store_1.AppStore.Form.exists(this.formVersion)) {
            return (0, mithril_1.m)('div', { className: exports.CSS.container }, (0, i18n_1.Translate)(i18n_1.T.FORM_NOT_FOUND));
        }
        if (this.designer.form == null) {
            return (0, mithril_1.m)('div', { className: exports.CSS.container });
        }
        return (0, mithril_1.m)('div', { className: exports.CSS.container }, this.designer.view());
    }
    onRemove() {
        if (this.designer != null) {
            this.designer.onRemove();
            this.designer = null;
        }
    }
}
exports.FormEditPage = FormEditPage;
//# sourceMappingURL=form.edit.page.js.map